import { css } from "@emotion/react";
import styled from "@emotion/styled";
import memoize from "memoize-one";
import { PureComponent } from "react";

import { Dropdown, DropdownList } from "@livechat/design-system";
import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import { withVar } from "themes/helpers";

interface IProps {
  onChange(text: string): void;
}

interface IState {
  dropdownVisible: boolean;
}

const wrapper = css`
  font-size: 14px;
  margin-right: 8px;
`;

const StyledDropdown = styled(Dropdown)`
  min-width: 150px;
`;

const DropdownContainer = styled.span`
  float: right;
  font-size: 16px;
  padding-right: 10px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor80
  };
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getListItems = (onItemSelect: (itemKey: string) => void) => [
  {
    itemId: "edit",
    content: "Edit",
    icon: <Icon name={IconsEnum.Edit} width="15px" height="15px" fill={withVar(DesignToken.ContentBasicPrimary)} />,
    onItemSelect,
  },
  {
    itemId: "delete",
    content: "Delete",
    icon: <Icon name={IconsEnum.TrashBin} width="15px" height="15px" fill={withVar(DesignToken.ContentBasicPrimary)} />,
    onItemSelect,
  },
];

export class ScheduledReportsDropdown extends PureComponent<IProps, IState> {
  state = {
    dropdownVisible: false,
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleButtonClick = () => {
    this.setState(prevState => ({
      dropdownVisible: !prevState.dropdownVisible,
    }));
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleClose = () => {
    this.setState({ dropdownVisible: false });
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleSelect = (itemKey: string) => {
    this.props.onChange(itemKey);
    this.handleClose();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createDropdownContainer = (ref: React.Ref<HTMLButtonElement>) => (
    <DropdownContainer onClick={this.handleButtonClick} ref={ref}>
      <Icon name={IconsEnum.More} width="15px" height="15px" fill={withVar(DesignToken.ContentBasicPrimary)} inline />
    </DropdownContainer>
  );

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { dropdownVisible } = this.state;
    const dropdownContainer = memoize(({ ref }) => this.createDropdownContainer(ref));

    return (
      <span css={wrapper}>
        <StyledDropdown
          isVisible={dropdownVisible}
          placement="bottom-end"
          onClose={this.handleClose}
          triggerRenderer={dropdownContainer}
        >
          {/* @ts-expect-error TS(2322) */}
          <DropdownList items={getListItems(this.handleSelect)} />
        </StyledDropdown>
      </span>
    );
  }
}
